// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22Yst","footer":"styles_footer__3k8cN"};